// extracted by mini-css-extract-plugin
export default {"eastereggs":"EasterEggs_eastereggs__g59kM","egg":"EasterEggs_egg__48Ay5","tooltip":"EasterEggs_tooltip__Yv2zd"};